var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"inline-flex items-center gap-1 text-sm font-medium text-theme-primary no-underline hover:underline",attrs:{"href":("/wiki/" + _vm.topic),"target":"_blank","rel":"noopener"}},[_vm._v(" 📚 Saber más ")])}
var staticRenderFns = []

export { render, staticRenderFns }